import React from "react";
import Countdown from "./Countdown";
import "./css/Banner.css";
import { Helmet } from "react-helmet";
import { FaArrowDown } from "react-icons/fa"; // using react-icons

const scrollToCommunity = () => {
  const el = document.getElementById("community-section");
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const Banner = () => {
  return (
    <>
      <Helmet>
        <title>GTAFanPage.com – Grand Theft Auto 6 News, Leaks & Community</title>
      </Helmet>
        <section className="banner-section">
          <Countdown />
          <div className="scroll-down" onClick={scrollToCommunity}>
            <FaArrowDown className="bounce-arrow" />
            <div className="scroll-text">Community</div>
          </div>
        </section>
    </>
  );
};

export default Banner;
